import React, {useEffect, useRef, useState} from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../../_metronic/helpers'
import InputGroup from 'react-bootstrap/InputGroup'
import {getClientContacts} from '../../../../components/requests'
import {ModeleClientContact} from '../../../../components/Models'
import AddContactModal from './AddContactModal'
import Swal from 'sweetalert2'
import {Tooltip} from 'react-tooltip'

const ChoixContactModal = (props) => {
  const [contacts, setContacts] = useState<Array<ModeleClientContact>>([])
  const [loading, setLoading] = useState(false)
  const createContactBtn = useRef<any>()
  const [isModalContactOpen, setIsModalContactOpen] = useState(false)
  const [objetCommunication, setObjetCommunication] = useState<any>({})
  const [isFromClientContact, setIsFromClientContact] = useState(false)
  const [tempContactedBy, setTempcontactedBy] = useState<any>(null)

  const [isErrorEmail, setIsErrorEmail] = useState('')
  const [isErrorSms, setIsErrorSms] = useState('')
  const [isErrorAppel, setIsErrorAppel] = useState('')
  const [dataContact, setDataContact] = useState<any>(null)

  const {
    clientId,
    setDefaultValueContact,
    defaultValueContact,
    setIsFromAddClientContact,
    setRadioValue,
    isFromClientList,
    setContactedBy,
    contactedBy,
    radioValue,
    setContentCommunication,
    contentCommunication,
    isDuplicate,
    toggleDuplicate,
    setIsDuplicate,
    isEdit,
    handleUpdateClientData,
    tempClientId,
    setTempClientId,
    setIsConfirmEdit,
    setContactedByBloc,
    demandeId,
    isFromDemandeList,
    openChoixContactOnClientChange,
    clientChangeLoader,
    refRechercheClient,
    setIsPrevious,
    searchTerm,
    setSearchTerm,
  } = props
  const idClient = isEdit === true ? tempClientId : clientId

  const validationRules = {
    email: {
      format: "L'email n'est pas valide",
      required: "L'email est requis",
      setError: setIsErrorEmail,
    },
    sms: {
      format: "Le numero n'est pas valide",
      required: 'Le numero est requis',
      setError: setIsErrorSms,
    },
    appel: {
      format: "Le téléphone n'est pas valide",
      required: 'Le téléphone est requis',
      setError: setIsErrorAppel,
    },
  }

  //fonction qui verifie le format du contenu / required  du champs de saisies
  const onKeyUpFields = (value, libelle) => {
    let isValid = true

    const rule = validationRules[libelle]
    if (!rule) return true

    const {format, required, setError} = rule
    //vérification required
    if (required && value.trim() === '') {
      setError(required)
      return
    }
    //vérification du format
    if (libelle === 'appel' || libelle === 'sms') {
      const phoneRegex = /^(?:\+33|33|0)[\s.-]*[1-9](?:[\s.-]?\d{2}){4}$/
      if (!phoneRegex.test(value)) {
        isValid = false
      }
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (!emailRegex.test(value)) {
        isValid = false
      }
    }
    if (format && !isValid) {
      setError(format)
      return
    }
    setError('')
  }

  const getClientData = () => {
    // A verifier
    // return
    setContentCommunication(isDuplicate ? contentCommunication?.toString() : '')
    setRadioValue(isDuplicate ? radioValue.toString() : 'email')
    setIsErrorEmail('')
    setIsErrorSms('')
    setIsErrorAppel('')

    setLoading(true)

    getClientContacts(idClient).then((res) => {
      if (res?.status === 200 && res?.data !== undefined) {
        if (res?.data.length === 0) {
          setContacts([])
          Swal.fire({
            title: 'Aucun contact trouvé',
            text: 'Vous devez créer un contact pour continuer.',
            icon: 'warning',
            confirmButtonText: 'Créer',
            cancelButtonText: 'Annuler',
            showCancelButton: true,
            confirmButtonColor: '#1BC5BD',
            cancelButtonColor: '#F64E60',
          }).then((alertResult) => {
            if (alertResult.isConfirmed) {
              createContactBtn.current.click()
            }
          })
        } else {
          if (res?.data.length === 1) {
            setDefaultValueContact(res?.data[0]?.id)
            setObjetCommunication({
              email: res?.data[0]?.email ?? '',
              mobile: res?.data[0]?.mobile ?? '',
              telephone: res?.data[0]?.telephone ?? '',
            })
          }
          //trier le contact en mettent toujours le contact principal en premier
          const sortedContacts = [
            ...res?.data.filter((c) => c.principal),
            ...res?.data.filter((c) => !c.principal),
          ]
          setContacts(sortedContacts)
          if (!isFromClientContact) {
            // Filtre des données pour avoir les objetCommunication
            let dataFilter = sortedContacts.filter((c) =>
              isDuplicate ? c.id === defaultValueContact : c.principal
            )
            // Si defaultValueContact ne figure pas dans la liste des contacts, prendre le contact principal
            if (dataFilter.length === 0) {
              dataFilter = sortedContacts
              setDefaultValueContact(dataFilter?.[0]?.id)
              setContentCommunication(dataFilter?.[0]?.email)
            }
            // Pour la duplication, garder la valeur passée
            if (!isDuplicate) setDefaultValueContact(dataFilter[0]?.id)
            setObjetCommunication({
              email: dataFilter[0]?.email ?? '',
              mobile: dataFilter[0]?.mobile ?? '',
              telephone: dataFilter[0]?.telephone ?? '',
            })
            // setContactedBy(dataFilter[0])
            setTempcontactedBy(dataFilter[0])
          }

          // Réinitialisation du radio bouton en "email" | inutile pour la duplication
          if (
            (defaultValueContact != null ||
              defaultValueContact !== undefined ||
              defaultValueContact !== '') &&
            !isDuplicate
          ) {
            setRadioValue('email')
          }
        }
        setIsDuplicate(false)
        setIsFromClientContact(false)
        setLoading(false)
      }
    })
  }

  useEffect(() => {
    const modalElement = document.getElementById('choixContactModal')

    if (modalElement) {
      modalElement.addEventListener('show.bs.modal', () => setIsModalContactOpen(true))
      modalElement.addEventListener('hide.bs.modal', () => setIsModalContactOpen(false))
    }

    return () => {
      if (modalElement) {
        modalElement.removeEventListener('show.bs.modal', () => setIsModalContactOpen(true))
        modalElement.removeEventListener('hide.bs.modal', () => setIsModalContactOpen(false))
      }
    }
  }, [])

  useEffect(() => {
    if (clientId && isModalContactOpen) {
      getClientData()
    }
  }, [clientId, isModalContactOpen])

  const handleRadioCheck = (e) => {
    setIsErrorAppel('')
    setIsErrorSms('')
    setIsErrorEmail('')
    if (!isFromClientList) {
      // Pour gérer les erreurs lors de la duplication
      toggleDuplicate()
    }
    setRadioValue(e.target.id)
  }

  // Choisir la première email s'il n'y a qu'une seule contact
  useEffect(() => {
    if (contacts.length === 1) {
      if (demandeId == undefined) {
        setContactedBy(contacts[0])
      }
      if (isFromDemandeList) {
        setContactedBy(contacts[0])
      }
      setTempcontactedBy(contacts[0])
    }
  }, [contacts])

  useEffect(() => {
    if (clientId) {
      let value = ''
      // Changer le contenu : pour la duplication, garder les valeurs passées
      if (radioValue === 'email') {
        value = isDuplicate ? contentCommunication : objetCommunication.email ?? ''
        setContentCommunication(value)
        setIsErrorEmail(value.toString() === '' ? "L'email est requis" : '')
      } else if (radioValue === 'sms') {
        value = isDuplicate ? contentCommunication : objetCommunication.mobile ?? ''
        setContentCommunication(value)

        if (value.toString() === '')
          setIsErrorSms(value.toString() === '' ? 'Le numero est requis' : '')
      } else {
        value = isDuplicate ? contentCommunication : objetCommunication.telephone ?? ''
        setContentCommunication(value)

        setIsErrorAppel(value.toString() === '' ? 'Le téléphone est requis' : '')
      }
    }
  }, [radioValue, objetCommunication])

  const handleChoicedContact = (contact) => {
    setDefaultValueContact(contact?.id)

    setObjetCommunication({
      email: contact?.email ?? '',
      mobile: contact?.mobile ?? '',
      telephone: contact?.telephone ?? '',
      nom: contact?.nom ?? '',
      prenom: contact?.prenom ?? '',
    })
    setTempcontactedBy(contact)
  }

  const handleAddContact = (contact: any = null) => {
    setDataContact(contact)
  }

  const handleSaveButton = () => {
    // setIsConfirmEdit(true)
    setContactedBy(tempContactedBy)
    handleUpdateClientData(tempClientId, radioValue, tempContactedBy, contentCommunication)
    if (setContactedByBloc) {
      setContactedByBloc(contentCommunication)
    }
  }

  const handleSaveOnListButton = () => {
    // setContactedBy(tempContactedBy)
    handleUpdateClientData((tempClientId, radioValue, tempContactedBy, contentCommunication) => {
      setContactedByBloc(contentCommunication)
      // setContactedBy(tempContactedBy)
    })
  }

  return (
    <>
      <div
        className='modal fade'
        id='choixContactModal'
        aria-hidden='true'
        aria-labelledby='exampleModalToggleLabel3'
        tabIndex={-1}
      >
        <div className='modal-dialog'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h5 className='modal-title' id='exampleModalToggleLabel3'>
                Choix d'un contact
              </h5>
              <div
                className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                data-bs-dismiss='modal'
                aria-label='Close'
              >
                <KTSVG
                  path='/media/icons/duotune/arrows/arr061.svg'
                  className='svg-icon svg-icon-2x'
                />
              </div>
            </div>
            <div className='modal-body overflow-auto'>
              <div className='pb-5 text-muted'>
                <span>Sélectionnez un contact et choisissez le mode de communication.</span>
              </div>
              <div className='mb-6 justify-content-center align-items-center'>
                <label className='col-lg-8 fw-bold fs-6'>Liste des contacts</label>
                <button
                  className='btn btn-sm btn btn-light-info col-lg-4'
                  data-bs-target='#add_contact'
                  data-bs-toggle='modal'
                  data-bs-dismiss='modal'
                  ref={createContactBtn}
                  onClick={() => handleAddContact()}
                >
                  <i className='ki-duotone ki-plus fs-3'></i>
                  Ajouter contact
                </button>
              </div>
              <div className='mb-6'>
                {loading ? (
                  <span
                    className='indicator-progress text-muted text-center'
                    style={{display: 'block'}}
                  >
                    Chargement du contact ...
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                ) : contacts.length > 0 ? (
                  contacts.map((contact) => {
                    return (
                      <div key={contact.id}>
                        <InputGroup className='mb-3 gap-2 w-100' id='select-add-group'>
                          <InputGroup.Text
                            id='basic-addon2'
                            onClick={() => handleChoicedContact(contact)}
                            style={{
                              width: '85%',
                              borderRadius: '0.475rem',
                              borderColor:
                                defaultValueContact && defaultValueContact === contact?.id
                                  ? '#9AC331'
                                  : '',
                              color: '#000',
                              cursor: 'pointer',
                              whiteSpace: 'normal',
                              height: 'auto',
                              textAlign: 'unset',
                            }}
                          >
                            {contact?.nom} {contact?.prenom}{' '}
                            {contact?.posteOccupe && `(${contact.posteOccupe})`}
                          </InputGroup.Text>
                          <InputGroup.Text
                            id='basic-addon2'
                            className='justify-content-center'
                            data-bs-target='#add_contact'
                            data-bs-toggle='modal'
                            data-bs-dismiss='modal'
                            data-tooltip-id='modal-tooltip'
                            data-tooltip-content='Modifier les informations du contact'
                            data-tooltip-place='top'
                            onClick={() => handleAddContact(contact)}
                            ref={createContactBtn}
                            style={{
                              borderRadius: '0.475rem',
                              cursor: 'pointer',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              alignSelf: 'flex-start',
                            }}
                          >
                            <i
                              className='ki-duotone ki-pencil fs-2x'
                              style={{
                                transition: 'color 0.3s ease',
                              }}
                            >
                              <span className='path1'></span>
                              <span className='path2'></span>
                            </i>
                          </InputGroup.Text>
                        </InputGroup>
                      </div>
                    )
                  })
                ) : (
                  <span>Aucun contact trouvé</span>
                )}
              </div>
              <div>
                <div className='form-label'>Mode de communication</div>
                <div className='d-flex justify-content-between'>
                  <div className=''>
                    <div className='form-check form-check-custom form-check-solid'>
                      <input
                        className='form-check-input'
                        type='radio'
                        value=''
                        id='email'
                        name='communication'
                        onChange={handleRadioCheck}
                        checked={radioValue == 'email' || radioValue == ''}
                      />
                      <label className='form-check-label' htmlFor='email'>
                        Email
                      </label>
                    </div>
                  </div>
                  <div className=''>
                    <div className='form-check form-check-custom form-check-solid'>
                      <input
                        className='form-check-input'
                        type='radio'
                        value=''
                        id='sms'
                        name='communication'
                        onChange={handleRadioCheck}
                        checked={radioValue == 'sms'}
                      />
                      <label className='form-check-label' htmlFor='sms'>
                        Mobile
                      </label>
                    </div>
                  </div>
                  <div className=''>
                    <div className='form-check form-check-custom form-check-solid'>
                      <input
                        className='form-check-input'
                        type='radio'
                        value=''
                        id='appel'
                        name='communication'
                        onChange={handleRadioCheck}
                        checked={radioValue == 'appel'}
                      />
                      <label className='form-check-label' htmlFor='appel'>
                        Fixe
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              {/* debut affichage de champs de saisie pour les types de communications*/}
              <div className='mt-5 col-lg-12'>
                <input
                  type={radioValue === 'email' ? 'email' : 'text'}
                  name='modeCommunication'
                  className='form-control form-control-lg form-control-solid mb-3 mb-lg-0 col-lg-12'
                  placeholder={
                    radioValue === 'email' ? 'Email' : radioValue === 'appel' ? 'Téléphone' : 'SMS'
                  }
                  value={contentCommunication}
                  onChange={(e) => {
                    setContentCommunication(e.target.value)
                    onKeyUpFields(
                      e.target.value,
                      radioValue === 'email' ? 'email' : radioValue === 'appel' ? 'appel' : 'sms'
                    )
                  }}
                />
                {isErrorEmail && <p className='text-danger'>{isErrorEmail}</p>}
                {isErrorSms && <p className='text-danger'>{isErrorSms}</p>}
                {isErrorAppel && <p className='text-danger'>{isErrorAppel}</p>}
              </div>
              {/* fin affichage de champs de saisie pour les types de communications*/}
            </div>
            <div className='modal-footer'>
              {isFromClientList ? (
                <button
                  type='button'
                  className='btn btn-light-secondary'
                  data-bs-dismiss='modal'
                  onClick={() => {
                    setDefaultValueContact('')
                  }}
                >
                  Fermer
                </button>
              ) : (
                <button
                  type='button'
                  className='btn btn-light-secondary'
                  data-bs-target='#exampleModalToggle'
                  data-bs-toggle='modal'
                  data-bs-dismiss='modal'
                  onClick={() => {
                    setDefaultValueContact('')
                    setRadioValue('email')
                    setContentCommunication('')
                    if (refRechercheClient?.current) {
                      refRechercheClient.current.click()
                    }
                    setIsPrevious(false)
                  }}
                >
                  Retour
                </button>
              )}
              {!isEdit ? (
                loading || !defaultValueContact || isErrorEmail || isErrorSms || isErrorAppel ? (
                  <button
                    type='button'
                    className='btn btn-light-primary disabled'
                    data-bs-dismiss='modal'
                  >
                    Suivant
                  </button>
                ) : (
                  <button
                    type='button'
                    className='btn btn-light-primary'
                    data-bs-target='#exampleModalSearchV'
                    data-bs-toggle='modal'
                    data-bs-dismiss='modal'
                    data-tooltip-id='modal-tooltip'
                    data-tooltip-content='Effectuer une demande'
                    data-tooltip-place='top'
                    onClick={() => setContactedBy(tempContactedBy)}
                  >
                    Suivant
                  </button>
                )
              ) : isFromDemandeList ? (
                <button
                  type='button'
                  className={`btn btn-light-primary ${clientChangeLoader ? 'disabled' : ''}`}
                  onClick={() => handleSaveOnListButton()}
                  disabled={loading}
                >
                  {!clientChangeLoader && 'Enregistrer'}
                  {clientChangeLoader && (
                    <span className='indicator-progress' style={{display: 'block'}}>
                      Enregistrement
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </button>
              ) : (
                <button
                  type='button'
                  className='btn btn-light-primary'
                  data-bs-dismiss={'modal'}
                  onClick={() => handleSaveButton()}
                  disabled={loading}
                >
                  Enregistrer
                </button>
              )}
            </div>
          </div>
        </div>
        <Tooltip id='modal-tooltip' />
      </div>
      <AddContactModal
        clientId={idClient}
        setDefaultValueContact={setDefaultValueContact}
        defaultValueContact={defaultValueContact}
        setIsFromAddClientContact={setIsFromAddClientContact}
        setIsFromClientContact={setIsFromClientContact}
        setObjetCommunication={setObjetCommunication}
        setContactedBy={setContactedBy}
        dataContact={dataContact}
      />
      <button
        type='button'
        className='d-none'
        data-bs-dismiss={'modal'}
        data-bs-target={'#kt_modal_1'}
        data-bs-toggle={'modal'}
        ref={openChoixContactOnClientChange}
      ></button>
    </>
  )
}

export default ChoixContactModal
